import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import TruncateText from "../../Components/Utility/TruncateText";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function UserProfile() {
  const [userData, setUserData] = useState(null);
  const [baseUrl, setBaseUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updated, setUpdated] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_BASE;
  const location = useLocation();
  const [meta,setMeta] = useState();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // ✅ Get token from localStorage
        const token = localStorage.getItem("authToken");

        if (!token) {
          setError("User not authenticated!");
          setLoading(false);
          return;
        }

        // ✅ API call with Authorization header
        const response = await axios.get(`${BASE_URL}/user/getuserProfile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const user = response.data.data;
        setUserData(user);
        setBaseUrl(response.data.base_url);

        // ✅ Check localStorage per-user flag
        const isUpdated =
          localStorage.getItem(`profileUpdated_${user.id}`) === "true";
        setUpdated(isUpdated);

        setLoading(false);
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Failed to load user profile");
        setLoading(false);
      }
    };

    fetchUserData();
  }, [BASE_URL]);

  // ✅ Check if updated state came from navigation
  useEffect(() => {
    if (location.state?.updated && userData?.id) {
      setUpdated(true);

      localStorage.setItem(`profileUpdated_${userData.id}`, "true"); // safe now

      // Clear state after showing success (so it doesn’t persist on refresh)
      window.history.replaceState({}, document.title);
    }
  }, [location.state, userData]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

   useEffect(() => {
      const loadMeta = async () => {
        const data = await fetchCmsMetaData("account");
        setMeta(data);
      };
  
      loadMeta();
    }, []);

  return (
    <section className="user_allls profiles pt-0 pb-0">
       <SetMetaTags
        title= {meta?.meta_title || "Account | Weyfarin"}
        description={meta?.meta_description || "Account | Weyfarin"}
      
      />

      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="prfo_listst lastsst">
            <h4>
              About Me{" "}
              <span className="edt_griht">
                <Link to={"/myprofile"}>Edit</Link>
              </span>
            </h4>
            <div className="row">
              <div className="col-lg-3">
                <div className="usr_profl">
                  <div className="usr_mgss">
                    {" "}
                    <img
                      src={
                        userData?.profile_image
                          ? `${baseUrl}${userData.profile_image}`
                          : "/images/user_dh.png" // ✅ your custom default image
                      }
                      alt="User Profile"
                    />
                  </div>
                  <p>
                    {userData?.first_name} {userData?.last_name}
                  </p>
                  {/* <span>{userData?.user_type === 1 ? "Guest" : "Host"}</span> */}
                </div>
              </div>
              <div className="col-lg-9">
                {!updated && (
                  <div className="discriptionns">
                    <h3>Complete your profile</h3>
                    <p className="sm_diss">
                      Your Weyfarin profile is an important part of every
                      reservation. Create yours to help other hosts and guests
                      get to know you.
                    </p>
                    <Link to={"/myprofile"} className="btnnss">
                      Get Started
                    </Link>
                  </div>
                )}

                {updated && (
                  <div className="discripss">
                    <TruncateText
                      res={{
                        description: `${userData?.about_me || ""}`,
                      }}
                      maxLength={250}
                    />

                    <div className="dts_listst">
                      <ul>
                        <li>
                          <strong>Date of Birth :</strong>{" "}
                          {userData?.dob
                            ? new Date(userData.dob).toLocaleDateString()
                            : "N/A"}
                        </li>
                        <li>
                          <strong>Gender :</strong>{" "}
                          {userData?.gender === 1
                            ? "Male"
                            : userData?.gender === 2
                            ? "Female"
                            : "Other"}{" "}
                        </li>
                        <li>
                          <strong>City :</strong> {userData?.city_name || "N/A"}
                        </li>
                        <li>
                          <strong>Occupation :</strong>{" "}
                          {userData?.occupation || "N/A"}
                        </li>
                        <li>
                          <strong>Language :</strong>{" "}
                          {userData?.language || "N/A"}
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UserProfile;
